import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconRegridingM: FC<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16 2.85714C16 1.27919 14.7208 0 13.1429 0H2.85714C1.27919 0 0 1.27919 0 2.85714V13.1429C0 14.7208 1.27919 16 2.85714 16H13.1429C14.7208 16 16 14.7208 16 13.1429V2.85714ZM1.14286 13.1429V11.4286H4.57143V14.8571H2.85714L2.69205 14.8493C1.82273 14.7662 1.14286 14.0339 1.14286 13.1429ZM10.2857 11.4286V14.8571H5.71429V11.4286H10.2857ZM13.1429 14.8571H11.4286V11.4286H14.8571V13.1429L14.8493 13.308C14.7662 14.1773 14.0339 14.8571 13.1429 14.8571ZM10.2857 5.71429V10.2857H5.71429V5.71429H10.2857ZM11.4286 5.71429H14.8571V10.2857H11.4286V5.71429ZM10.2857 1.14286V4.57143H5.71429V1.14286H10.2857ZM11.4286 1.14286H13.1429L13.308 1.1507C14.1773 1.23377 14.8571 1.96606 14.8571 2.85714V4.57143H11.4286V1.14286ZM4.57143 1.14286V4.57143H1.14286V2.85714L1.1507 2.69205C1.23377 1.82273 1.96606 1.14286 2.85714 1.14286H4.57143ZM4.57143 5.71429V10.2857H1.14286V5.71429H4.57143Z" />
  </svg>
)

export const IconRegriding = createIcon({
  name: 'IconRegriding',
  l: IconRegridingM,
  m: IconRegridingM,
  s: IconRegridingM,
  xs: IconRegridingM,
})
